const plans = [
  'free',
  'standard',
  'premium',
  'enterprise'
]

export {plans}